import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 14h4v-4H3v4zm0 5h4v-4H3v4zM3 9h4V5H3v4zm5 5h12v-4H8v4zm0 5h12v-4H8v4zM8 5v4h12V5H8z"
}), 'ViewListSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewListSharp.js
// module id = 7108
// module chunks = 2